import * as React from 'react';
import { useState } from 'react';
import { Link} from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner, InputGroup } from "react-bootstrap";
import vindrApi from "../utils/vindrapi";
import {formatDate} from "../utils/functions";
import parse from 'html-react-parser';
import Filter from "../components/Filter";
import LibraryItem from "../components/LibraryItem";
import LayerUpload from "../components/LayerUpload";
import Country from "../classes/Country";
import DataTableFilter from "../components/DataTableFilter";
import DialogPrompt from "../layouts/DialogPrompt";

		
class DialogLayerLibrary extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		var inUse = this.getInUse();
		this.sortOptions = [
			{label: "Recently added", value:"sortByDate"},
			{label: "Name", value:"sortByName"}
		];
		
		this.state = {
			filterCountry:  new Array(),
			filterFolder:  ['personalUploads'],
			data: [],
			pending: true,
			inUse: inUse,
			showFilters : false,
			needle:'',
			sort: this.sortOptions[0].value,
			dialogPrompt:{open:false},
			...this.props.user.settings.libraryFilters
		}
		this.uploaderOpts = [
			{label:'Personal library', value:'personalUploads'},
			{label:'Vindr library', value:'libraryUploads'},
		];
		
		/* in screening mode there is no project */
		if(this.props.project)
			this.uploaderOpts = [...this.uploaderOpts, ...[{label:this.props.project.name+' layers', value:'projectUploads'}]   ];
		
		if(this.props.user.libraryFilters && this.props.user.libraryFilters.filterCountry)
			this.state.filterCountry = this.props.user.libraryFilters.filterCountry;
		
		/* fix for some users that might have a weird value here*/
		if(!this.state.filterFolder || !this.folderExists(this.state.filterFolder[0]))
			this.state.filterFolder = ['personalUploads'];
		
		
		this.countryComp = React.createRef();
	}
	getInUse(){
		return this.props.inUse.map((l)=>{
			if(!l.droppable)
				return l.data.id;
			return false;
		});
	}
	componentDidUpdate(prevProps) {
		var self = this;
		
		var newInUse = this.getInUse();
		
		if(prevProps.inUse.length != newInUse.length){
			
			self.updateStatus({inUse:newInUse});
			
		}
	}
	
	folderExists(value){
		
		const idx = this.uploaderOpts.findIndex((i)=>{
			return i.value == value;
		})
		return (idx > -1);
	}
	
	getIdentifyer(item){
		return item.tablename ? item.tablename+'-'+item.id : 'raster-'+item.id+'-layer';
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	
	handleClose(data){
		this.props.onClose(data);
		this.setState({ data: [], pending:true });
	};
	handleOnShow(e){
		
		/* projectid 0 if we are calling this from screening page (no project)*/
		const projectId = this.props?.project?.projectid ?? 0;
		
		vindrApi.getLayers(this.props.user.userDetails, projectId).then((layers)=>{

			this.updateStatus({data:layers,  pending:false});

		});

		
	};
	
	handleUpload(e){
		if(this.props.onUpload)
			this.props.onUpload(e);
	}
	addInUse(layer){
		var inUse = this.state.inUse.slice(0);
		inUse.push(this.getIdentifyer(layer));
		
		this.updateStatus({inUse:inUse});
	}
	remInUse(layer){
		if(typeof layer === 'string'){
			var id = layer;
		}
		else {
			var id = this.getIdentifyer(layer);
		}
		
		var inUse = this.state.inUse.filter((a)=>{return a!=id;});
		
		this.updateStatus({inUse:inUse});
	}
	
	handleOnSelect(layer, inUse){
		if(inUse){
			this.remInUse(layer);
			if(this.props.onDeSelect)
				this.props.onDeSelect(layer);
			return;
		}
			
		
		this.addInUse(layer);
		
		if(this.props.onSelect)
			this.props.onSelect(layer);
	}
	selectFilter(filter, opts){
		
		var state = structuredClone(this.state);
		
		state[filter] = opts.map((a)=>{return a.value});
		this.updateStatus(state);
		this.saveFilter(filter, state[filter]);
	}
	noResults(){
		return (<b className="mt-3 ms-3">No results found. Try refining your search or removing one of your filters.</b>)
	}
	
	filtered(item, personalTab){
		
		return (
			(personalTab || !this.state.filterCountry.length || item.countries.filter((value) => {return this.state.filterCountry.includes(value) || value == "All"}).length)
			
		)
	}
	searchNeedle(item){
		
		if(this.state.needle.length < 3)
			return true;
		
		const searchPat = new RegExp(this.state.needle.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i");
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(
			( item.name && item.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "").match(searchPat)  ) || 
			( item.description && item.description.normalize('NFD').replace(/[\u0300-\u036f]/g, "").match(searchPat) )
		)
	}
	handleSortChange(e){
		this.updateStatus({sort:e.target.value});
	}
	sortByName(items){
		return items.sort( (a,b)=>{
			if ( a.name < b.name ){
				return -1;
			}
			if ( a.name > b.name ){
				return 1;
			}
			return 0;
		} );
		
	}
	sortByDate(items){
		return items.sort( (b,a)=>{
			return (new Date(a.upload_date)-new Date(b.upload_date));
		} );
		
	}
	deleteLayer(item){
		return vindrApi.deleteLayer(item.id);
	}
	handleDeleteItem(item){
		this.handleOnShow({});
	}
	toggleFilters(e){
		e.stopPropagation();
		if(!this.state.showFilters && !this.listenerSet){
			window.addEventListener('click', () => {
				this.updateStatus({showFilters:false});
			});
			this.listenerSet = true;
		}
		
		this.updateStatus({showFilters:!this.state.showFilters});
	}
	saveFilter(filter, value){
		var user = this.props.user;
		
		if(user && user.userDetails && user.settings){
			if(!user.settings.libraryFilters)
				user.settings.libraryFilters = {};
			user.settings.libraryFilters[filter] = value;
			user.email = user.userDetails;

			vindrApi.updateSettings(user);
		}
		
	}
	renderLayers(){
		var highlight = '';
		
		const noFilters = this.state.filterFolder.length && ['personalUploads', 'projectUploads'].includes(this.state.filterFolder[0]);
		
		if(!this.state.pending){
			
			if(!this.state.data[this.state.filterFolder].length)
				return this.noResults();
			
			var foundResults = false;
			
			//sort
			var sorted = [...this.state.data[this.state.filterFolder]];
			sorted = this[this.state.sort](sorted);
			
			var upload = null;
			if(this.state.filterFolder.length && ['libraryUploads'].includes(this.state.filterFolder[0])){
				upload = (<Card className={"card-layer upload m-2 my-3"} onClick={(e)=>{this.handleUpload(e);}}>
					<Card.Body>
						<i className="ri-add-large-line"></i>
						<div>Upload layer...</div>
					</Card.Body>
				</Card>);
			}
			
			var results = sorted.map((item, k)=>{
				var alreadyUsed = this.state.inUse.includes(this.getIdentifyer(item));
				
				
				if(
					this.filtered(item, noFilters) &&
					this.searchNeedle(item)
				){
					foundResults = true;
					return (
						<LibraryItem jkey={k} used={alreadyUsed} item={item} onDelete={(e)=>{return this.promptDelete(item)}} onUpdate={(e)=>{this.handleOnShow({})}} onSelect={(item, alreadyUsed)=>this.handleOnSelect(item, alreadyUsed)} />
					);
				}
			});
			return foundResults ? [...[upload], ...results] : this.noResults();
		}
		
		
	}
	
	promptDelete(item){
		
		this.updateStatus({
			dialogPrompt: {
				open:true, 
				text : {
					title: "Delete layer"
				}, 
				onConfirm:()=>{return this.deleteLayer(item)}, 
				onClose:()=>{this.updateStatus({dialogPrompt:{open:false}}); this.handleDeleteItem(item)}
			}
		});
	}

	render() {
		
		const personal = this.state.filterFolder.length && ['personalUploads', 'projectUploads'].includes(this.state.filterFolder[0]);
		
		return (
			<>
				<Modal className="layer-library" show={!!this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
					<Modal.Header>
						<Modal.Title>Layer library</Modal.Title>
						<span onClick={(e)=>{this.handleUpload(e);}} className="btn btn-primary btn-sm ms-auto"><i className="ri-upload-2-line"></i> Upload layer</span>
						
						<span onClick={(e)=>{this.handleClose();}} className="btn btn-close alt btn-sm float-end"><i className="ri-close-large-line"></i></span>
							
							
					</Modal.Header>
					<Modal.Body className="pt-0">

						{
							this.state.pending ? 
								<div className="text-center my-5 py-5"><Spinner animation="border" variant="success"  /> </div>
							: 
							(<>
								<Row className=" row-tabs px-3">
									<Col xs="12" className="library-filters">
										<Filter options={this.uploaderOpts} defaultValue={this.state.filterFolder.map((u)=>{return {label:u, value:u};})} onChange={(a)=>{this.selectFilter("filterFolder", a)}} placeholder="All" isSearchable={false} />
									</Col>
								</Row>
								<Row className="row p-2 pt-4 align-items-center">		
									<Col xs="3">

										<DataTableFilter value={this.state.needle} onChange={(value)=>{this.updateStatus({needle:value})}} />
									</Col>

									<Col xs="6" className="pt-0 filter-wrp">
									
									{!personal && <> 
										<button className="btn p-1 px-2" onClick={(e)=>{ this.toggleFilters(e);}}><i role="button" className="ri-equalizer-2-line"></i></button>

										<Card onClick={(e)=>{e.stopPropagation();}} className={"projects-filter-panel text-start shadow-sm "+(this.state.showFilters ? "d-block opacity-100" : "opacity-0")}>
											<Card.Body>
												<div className="g-3 pb-4">
													<div><b>Countries</b></div>
													<Filter ref={this.countryComp} options={Country.options} defaultValue={this.state.filterCountry.map((a)=>{return {value:a, label:a};})} onChange={(a)=>{this.selectFilter("filterCountry", a)}} placeholder="All" isSearchable={false} isMulti />
												</div>
											</Card.Body>
										</Card>
										<div className="active-filters">
										{
											Array.from(this.state.filterCountry).map((a, idx)=>{
												return (<span key={idx} className="filter-text d-inline-block p-2 px-2 me-4 rounded ">{a} <i role="button" onClick={()=>{this.countryComp.current.deSelect(a)}} className="ri-close-line"></i></span>)
											})

										}</div>
										</>
									}
									</Col>
									<Col xs="3" className="sort-options">
										Sort by: 
										<Form.Select className="branded-select" onChange={(e)=>{this.handleSortChange(e);}} defaultValue={this.state.sort}>
											{this.sortOptions.map((o, k)=>{return (<option key={k} value={o.value}>{o.label}</option>)})}
										</Form.Select>
									</Col>
								</Row>
								<Row>
									<Col xs="12">

										{/*!!this.state.filterUploader.length && this.state.filterUploader[0] == 'vindr' && 
											<div className="layer-library-filtertop">
												<h5>Countries</h5>
												<Filter options={countryOpts} defaultValue={this.state.filterCountry.map((a)=>{return {value:a, label:a};})} onChange={(a)=>{this.selectFilter("filterCountry", a)}} placeholder="All" isSearchable={false} isMulti />
												<br />
											</div>
										*/}
										<div className="layer-library-list">
											
											{this.renderLayers()}
										</div>


									</Col>
								</Row>
							</>
							)
						}


					</Modal.Body>
				</Modal>
				<DialogPrompt setup={this.state.dialogPrompt} />
			</>
		);
	}
}

export default DialogLayerLibrary;